import styled, { css } from 'styled-components';
var OpeningHoursListItem = styled.li.withConfig({
  displayName: "OpeningHoursstyles__OpeningHoursListItem",
  componentId: "vh71a9-0"
})(["display:flex;justify-content:center;text-align:center;"]);
var OpeningHoursWrapperSpan = styled.span.withConfig({
  displayName: "OpeningHoursstyles__OpeningHoursWrapperSpan",
  componentId: "vh71a9-1"
})(["padding:3px 5px 2px;width:calc(100% + 10px);margin:0 -5px 0;border-radius:3px;display:flex;justify-content:space-between;", ""], function (props) {
  return props.active && css(["background:", ";font-weight:", ";"], props.theme.color.monochrome.light, props.theme.font.weight.bold);
});
var OpeningHoursDaySpan = styled.span.withConfig({
  displayName: "OpeningHoursstyles__OpeningHoursDaySpan",
  componentId: "vh71a9-2"
})(["font-weight:", ";text-align:left;display:inline-block;width:28px;"], function (props) {
  return props.theme.font.weight.bold;
});
var OpeningHoursTimeWrapper = styled.span.withConfig({
  displayName: "OpeningHoursstyles__OpeningHoursTimeWrapper",
  componentId: "vh71a9-3"
})(["display:inline-block;"]);
var OpeningHoursTimeStartSpan = styled.span.withConfig({
  displayName: "OpeningHoursstyles__OpeningHoursTimeStartSpan",
  componentId: "vh71a9-4"
})(["display:inline-block;width:40px;text-align:left;margin:0;@media (min-width:", "){margin-right:40px;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
var OpeningHoursTimeSpacerSpan = styled.span.withConfig({
  displayName: "OpeningHoursstyles__OpeningHoursTimeSpacerSpan",
  componentId: "vh71a9-5"
})(["display:none;"]);
var OpeningHoursTimeEndSpan = styled.span.withConfig({
  displayName: "OpeningHoursstyles__OpeningHoursTimeEndSpan",
  componentId: "vh71a9-6"
})(["display:inline-block;width:40px;text-align:left;margin-left:20px;@media (min-width:", "){margin-left:0;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
var OpeningHoursWrapper = styled.div.withConfig({
  displayName: "OpeningHoursstyles__OpeningHoursWrapper",
  componentId: "vh71a9-7"
})(["max-width:200px;width:100%;margin:0 auto;"]);
var OpeningHoursTitleSrOnly = styled.div.withConfig({
  displayName: "OpeningHoursstyles__OpeningHoursTitleSrOnly",
  componentId: "vh71a9-8"
})(["clip:rect() (1px,1px,1px,1px);position:absolute;width:1px;height:1px;overflow:hidden;"]);
var OpeningHoursList = styled.ul.withConfig({
  displayName: "OpeningHoursstyles__OpeningHoursList",
  componentId: "vh71a9-9"
})(["padding:0;list-style:none;"]);
export { OpeningHoursListItem, OpeningHoursWrapperSpan, OpeningHoursDaySpan, OpeningHoursTimeWrapper, OpeningHoursTimeStartSpan, OpeningHoursTimeSpacerSpan, OpeningHoursTimeEndSpan, OpeningHoursWrapper, OpeningHoursTitleSrOnly, OpeningHoursList };